export const ACCOUNT_ENUM = {
  SUPER_ADMIN: "Super Admin",
  CS: "Customer Services",
  ADMIN: "Admin",
  USER: "User",
};
